export const isIdValid = (id: string): boolean => {
    return typeof id === "string" && id.trim() !== "";
}

const turkishPhoneRegex = /^(?:5\d{9}|\(5\d{2}\)\s\d{3}\s\d{2}\s\d{2})$/;
const intlPhoneRegex = /^[1-9]\d{3,14}$/;
const azerbaijaniPhoneRegex = /^\((10|50|51|55|60|70|77)\)\s\d{3}\s\d{2}\s\d{2}$/;
const usPhoneRegex = /^(\+1\s?)?(\(?[2-9]\d{2}\)?[\s-]?)\d{3}[\s-]?\d{4}$/;

export const isPhoneNumberValid = (phoneNumber: string, countryCode: string): boolean => {
    if(!countryCode || countryCode.trim() === "") {
        return false;
    }
    countryCode = countryCode.toLowerCase();

    if (typeof phoneNumber !== 'string') {
        phoneNumber = String(phoneNumber);
    }

    if (!phoneNumber || phoneNumber.trim() === "") {
        return false;
    }

    if (countryCode === "tr") return turkishPhoneRegex.test(phoneNumber);
    else if (countryCode === "az") return azerbaijaniPhoneRegex.test(phoneNumber);
    else if (countryCode === "us") return usPhoneRegex.test(phoneNumber);
    return intlPhoneRegex.test(phoneNumber);
}

const emailRegexRFC = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;

export const isEmailValid = (email: string): boolean => {
    if (!email || email.trim() === "") {
        return false;
    }

    return emailRegexRFC.test(email);
}